import { ClientScoreHealthRangeProps } from '..';
import { ClientScoreHealthRange } from '../ScoreHealthRange';
import { TAX_RATE_SCORE_HEALTH_RANGE_BREAKPOINTS } from './constants';
import { TAX_RATE_SCORECARD_ELEMENT_SYMBOL } from '../../../Scorecard';

export function ClientTaxRateScoreHealthRange(props: Omit<ClientScoreHealthRangeProps, 'breakpoints' | 'element'>) {
  return (
    <ClientScoreHealthRange
      {...props}
      element={TAX_RATE_SCORECARD_ELEMENT_SYMBOL}
      breakpoints={TAX_RATE_SCORE_HEALTH_RANGE_BREAKPOINTS}
    />
  );
}
